import instance from "./apiInstance";

const STORAGE_KEY = "sp_promos_v1";
const MAX_AGE_MS = 2 * 60 * 1000;

let memoryCache = null;
let fetchPromise = null;

function getThumbUrl(url) {
  if (!url) return "";
  const clean = url.split("?")[0];
  const dot = clean.lastIndexOf(".");
  if (dot === -1) return clean;
  return clean.slice(0, dot) + "_thumb.jpg";
}

function warmImageCache(promos) {
  if (!promos?.length) return;
  promos.forEach((promo) => {
    const prods = (promo.products || []).filter((p) => p.image_url);
    // Preload top thumbnails
    prods.slice(0, 4).forEach((p) => {
      const img = new Image();
      img.decoding = "async";
      img.src = getThumbUrl(p.image_url);
      img.onerror = () => {
        // Fallback para imagem original se _thumb não existir no S3
        const fallback = new Image();
        fallback.decoding = "async";
        fallback.src = p.image_url;
      };
    });
    // Preload imagem full do primeiro story
    if (prods[0]?.image_url) {
      const fullImg = new Image();
      fullImg.decoding = "async";
      fullImg.src = prods[0].image_url;
    }
  });
}

function readStorage() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { ts, data } = JSON.parse(raw);
    if (Date.now() - ts > MAX_AGE_MS) return null;
    return data;
  } catch {
    return null;
  }
}

function writeStorage(data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), data }));
  } catch {}
}

export function getCachedPromos() {
  if (memoryCache) return memoryCache;
  const stored = readStorage();
  if (stored) memoryCache = stored;
  return memoryCache;
}

export function prefetchPromos() {
  const cached = getCachedPromos();
  if (cached) {
    warmImageCache(cached);
    return Promise.resolve(cached);
  }
  if (fetchPromise) return fetchPromise;
  fetchPromise = instance
    .get("/promos/active")
    .then((res) => {
      const promos = res.data.promos || [];
      memoryCache = promos;
      writeStorage(promos);
      warmImageCache(promos);
      return promos;
    })
    .catch(() => null)
    .finally(() => { fetchPromise = null; });
  return fetchPromise;
}

export function fetchPromos(signal) {
  const cached = getCachedPromos();
  if (cached) {
    const bgRefresh = instance
      .get("/promos/active", { signal })
      .then((res) => {
        const fresh = res.data.promos || [];
        memoryCache = fresh;
        writeStorage(fresh);
        return fresh;
      })
      .catch(() => null);
    return { immediate: cached, refresh: bgRefresh };
  }

  if (fetchPromise) {
    return { immediate: null, refresh: fetchPromise };
  }

  const promise = instance
    .get("/promos/active", { signal })
    .then((res) => {
      const promos = res.data.promos || [];
      memoryCache = promos;
      writeStorage(promos);
      warmImageCache(promos);
      return promos;
    });
  return { immediate: null, refresh: promise };
}
